module.exports = __webpack_public_path__ + "images/aiways540aeebb44bafc635ab77fd832d3020e.png";